<template>
  <div class="voice-to-text-container">
    <div class="trigger-area">
      <slot>
        <VoiceImage ref="voiceImage" :styleTemp="styleTemp" :customdeskId="customdeskId" />
      </slot>
    </div>
  </div>
</template>

<script>
import VoiceImage from './voiceImage.vue'

export default {
  name: 'VoiceToText',
  props: {
    customdeskId: {
      type: String,
      default: ''
    },
    styleTemp: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
    };
  },
  components: {
    VoiceImage,
  },
}
</script>

<style scoped>
.voice-to-text-container {
  height: 0;
}
</style>